
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/hip",
      function () {
        return require("private-next-pages/services/hip.tsx");
      }
    ]);
  